<div class="modal-header">
  <h3 class="modal-title">Preis aus Preisliste</h3>
</div>


<form name="article" class="form-horizontal" [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-body">

    <div class="row">
      <div class="col-xs-1">
        Für die Stückzahl
      </div>
      <div class="col-xs-1">
        <select type="number" class="form-control input-sm" id="quantity" name="quantity"
          formControlName="quantity">
          @for (q of showQuantities(); track q) {
            <option [ngValue]="q" [selected]="q === selectedQuantity">
              {{q}}
            </option>
          }
        </select>

      </div>
      <div class="col-xs-1">
        mit der Losemenge
      </div>
      <div class="col-xs-1">
        <select type="number" class="form-control input-sm" id="lose" name="lose" formControlName="lose" (change)="toggleQuantity()">
          @for (q of showLoses(); track q) {
            <option [ngValue]="q" [selected]="q === selectedLose">
              {{q}}
            </option>
          }
        </select>
      </div>
      <div class="col-xs-3">
        existiert bereits ein Preis in der Preisliste:
      </div>
    </div>

    <div>&nbsp;</div>

    <div class="pricecheck-modal-row">

      <div class="pricecheck-modal-empty">
        <h3>Preisliste</h3>
      </div>

      <div class="pricecheck-modal-empty">
        <h3>Neu kalkulierter Preis</h3>
      </div>

    </div>

    @if (positionData.de.releases && showDe()) {
      <div class="pricecheck-modal-row">
        <div class="pricecheck-modal-empty">
          <span class="bold col-sm-12 headline"><img src="/ui/assets/images/flags/de.png" title="DE"> Deutschland</span>
          <table class="table whitetable">
            <thead>
              <tr>
                <th>K-ME</th>
                <th>Lose</th>
                <th>Freigabe</th>
                <th>Einzel €</th>
                <th>Kalk</th>
                <th>Datum</th>
                <th>Notiz</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              @for (release of positionData.de.releases; track release) {
                <tr
                  [ngClass]="{'selected': isSelected(false, 'de', $safeNavigationMigration(release?.release))}"
                  class="selectable-row"
                  (click)="select(false, 'de', release.release, release.notes)">
                  @if (release.calc_quanity) {
                    <td> {{ release.calc_quanity }} </td>
                  }
                  @if (!release.calc_quanity) {
                    <td>{{release.quanity}}</td>
                  }
                  <td> {{ release.lose }} </td>
                  <td> {{ release.release }} </td>
                  <td> <strong>{{ release.single }}</strong> </td>
                  <td> <strong>{{ release.calc }}</strong> </td>
                  <td> {{ release.date|date: "dd.MM.yyyy" }} </td>
                  <td class="notes-truncated-modal" title="{{release.notes}}">
                    @if (release.notes) {
                      <span class="notes-inner">
                        {{ release.notes }}
                      </span>
                      } &nbsp;
                    </td>
                    <td>
                      <div class="release-warning">
                        @if (articleChange(release.article_hash)) {
                          <span> Artikeländerung. </span>
                        }
                        @if (calculationChange(release.calc, 'de')) {
                          <span> Kalkulation wurde geändert! </span>
                        }
                        @if (priceChange('de', release)) {
                          <span> Es wurde eine Preiserhöhung angewandt. </span>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div>
            <table class="table whitetable">
              <thead>
                <tr>
                  <th>K-ME</th>
                  <th>Lose</th>
                  <th>Freigabe</th>
                  <th>Einzel €</th>
                  <th>Kalk</th>
                </tr>
              </thead>
              <tbody>
                <tr class="selectable-row" [ngClass]="{'selected': isSelected(true, 'de', null)}" (click)="select(true, 'de', null)">
                  <td>{{positionData.de.calc_quanity}}</td>
                  <td> {{ positionData.de.releases[0]?.lose }}</td>
                  <td> &nbsp; </td>
                  <td><strong>{{positionData.de.calculated?.price}}</strong></td>
                  <td><strong>{{positionData.de.calc}}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (positionData.cn.releases && showCn()) {
        <div class="pricecheck-modal-row">
          <div class="pricecheck-modal-empty">
            <span class="bold col-sm-12 headline"><img src="/ui/assets/images/flags/cn.png" title="DE"> China</span>
            <table class="table whitetable">
              <thead>
                <tr>
                  <th>K-ME</th>
                  <th>Lose</th>
                  <th>Freigabe</th>
                  <th>Einzel €</th>
                  <th>Kalk</th>
                  <th>Datum</th>
                  <th>Notiz</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                @for (release of positionData.cn.releases; track release) {
                  <tr
                    [ngClass]="{'selected': isSelected(false, 'cn', $safeNavigationMigration(release?.release))}" class="selectable-row"
                    (click)="select(false, 'cn', release.release, release.notes)">
                    @if (release.calc_quanity) {
                      <td> {{ release.calc_quanity }} </td>
                    }
                    @if (!release.calc_quanity) {
                      <td>{{release.quanity}}</td>
                    }
                    <td> {{ release.lose }} </td>
                    <td> {{ release.release }}</td>
                    <td> <strong>{{ release.single }}</strong> </td>
                    <td> <strong>{{ release.calc }}</strong> </td>
                    <td> {{ release.date|date: "dd.MM.yyyy" }} </td>
                    <td class="notes-truncated-modal" title="{{release.notes}}">
                      @if (release.notes) {
                        <span class="notes-inner">
                          {{ release.notes }}
                        </span>
                        } &nbsp;
                      </td>
                      <td>
                        <div class="release-warning">
                          @if (articleChange(release.article_hash)) {
                            <span> Artikeländerung. </span>
                          }
                          @if (calculationChange(release.calc, 'cn')) {
                            <span> Kalkulation wurde geändert! </span>
                          }
                          @if (priceChange($safeNavigationMigration(release?.last_price_id), 'cn')) {
                            <span> Es wurde eine Preiserhöhung angewandt. </span>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div>
              <table class="table whitetable">
                <thead>
                  <tr>
                    <th>K-ME</th>
                    <th>Lose</th>
                    <th>Freigabe</th>
                    <th>Einzel €</th>
                    <th>Kalk</th>
                  </tr>
                </thead>
                <tbody>
                  <tr [ngClass]="{'selected': isSelected(true, 'cn', null)}"
                    (click)="select(true, 'cn', null)"
                    class="selectable-row">
                    <td>{{positionData.cn.calc_quanity}}</td>
                    <td> {{ positionData.cn.releases[0]?.lose }}</td>
                    <td> &nbsp; </td>
                    <td><strong>{{positionData.cn.calculated?.price }}</strong></td>
                    <td><strong>{{positionData.cn.calc}}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }


      </div>

      <div class="modal-footer">

        <button class="btn btn-default pull-left" type="button"
          (click)="dismiss()">
          Abbrechen
        </button>

        <button class="btn btn-success pull-right" type="submit">
          Übernehmen
        </button>

      </div>

    </form>
